export default "__VITE_ASSET__XtBIbWfh__"